import React from "react";
import Seo from "@/components/Seo";
import { Container } from "@/components/Section";

export default function Terms() {
  return (
    <div data-testid="terms-page">
      <Seo title="Terms & Disclaimer" description="Terms of use and disclaimer for the Prasad Tutor Group (PTG) website." />
      <Container className="py-16 sm:py-24 max-w-3xl">
        <h1 className="font-heading text-4xl font-extrabold text-slate-900 tracking-tight">Terms & Disclaimer</h1>
        <p className="text-sm text-slate-400 mt-2">Last updated: June 2026</p>
        <div className="prose prose-slate mt-8 space-y-5 text-slate-600 leading-relaxed">
          <p>This page sets out the terms and disclaimer for the Prasad Tutor Group (PTG) website.</p>
          <h2 className="text-xl font-bold text-slate-800">Use of Website</h2>
          <p>The content on this website is provided for general information about PTG's coaching services. By using this website you agree to use it lawfully and not to misuse any forms or features.</p>
          <h2 className="text-xl font-bold text-slate-800">Results Disclaimer</h2>
          <p>Individual student outcomes may vary and depend on many factors.</p>
          <h2 className="text-xl font-bold text-slate-800">External Links</h2>
          <p>This website may link to external platforms such as YouTube, Instagram and WhatsApp. PTG is not responsible for the content or privacy practices of those third-party services.</p>
          <h2 className="text-xl font-bold text-slate-800">Contact</h2>
          <p>For questions about these terms, please contact PTG using the details on our Contact page.</p>
        </div>
      </Container>
    </div>
  );
}
